/// <reference path="../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Modals;
    (function (Modals) {
        var BaseModalController = /** @class */ (function () {
            function BaseModalController($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.initResult(ModalActionResult.Dismissed);
            }
            BaseModalController.prototype.initResult = function (action) {
                this.result = this.result || { action: action };
                this.result.action = action;
                return this.result;
            };
            /**
             * Closes the modal and returns an action of Dismissed in the returned promise.
             */
            BaseModalController.prototype.cancel = function () {
                this.$uibModalInstance.close(this.initResult(ModalActionResult.Dismissed));
            };
            /**
             * Closes the modal and returns an action of Failure in the returned promise.
             * @returns - ModalActionResult.Failed
             */
            BaseModalController.prototype.fail = function () {
                this.$uibModalInstance.close(this.initResult(ModalActionResult.Failed));
            };
            /**
             * Closes the modal and returns an action of Saved in the returned promise.
             * @returns - ModalActionResult.Saved
             */
            BaseModalController.prototype.save = function () {
                this.$uibModalInstance.close(this.initResult(ModalActionResult.Saved));
            };
            BaseModalController.$inject = ['$uibModalInstance'];
            return BaseModalController;
        }());
        Modals.BaseModalController = BaseModalController;
        angular
            .module('app.Modals')
            .controller('BaseModalController', BaseModalController);
    })(Modals = app.Modals || (app.Modals = {}));
})(app || (app = {}));
